import React from 'react';

function WidgetTitle(props) {

    return (
        <div className="row row-cols-auto justify-content-start align-items-center">
            <div className="col">
                <h4 className="mb-0 text-cl-black ff-univanova-600 fz-20">{props.title}</h4>
            </div>
        </div>
    );
}

export default WidgetTitle;